// Module-level counter used as a key on <RouterView> in AppLayout.
// Incrementing it forces Vue to tear down and remount the active view,
// which re-runs all data fetching — the same behaviour Gmail gives when
// you click the active nav item again.
import { ref } from 'vue'

const key = ref(0)

export function useNavRefresh() {
  return {
    key,
    refresh() {
      key.value++
    },
  }
}
